export default __webpack_public_path__ + "static/media/cressa-price.11a9b340.jpg";